/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { Button, TextField } from '@coursera/cds-core';
import { AddIcon, InfoOutlineIcon } from '@coursera/cds-icons';

import TooltipOverlay from 'bundles/grading/components/common/TooltipOverlay';

import _t from 'i18n!nls/grading';

const styles = {
  verticalAlignRow: () => css`
    display: flex;
    align-items: center;
  `,
  container: () => css`
    margin-top: var(--cds-spacing-400);
  `,
  tooltipIcon: () => css`
    display: flex;
    margin: 0 var(--cds-spacing-200);
  `,
};

// Comment box used for learner and staff comments
const CommentBox: React.FC<{
  button: {
    label: string;
    disabled: boolean;
    dataTestId: string;
  };
  tooltip: {
    id: string;
    text: string;
  };
  input: {
    label: string;
    value: string;
    disabled: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  };
}> = ({ button, tooltip, input }) => {
  const [showCommentBox, setShowCommentBox] = useState(!!input.value);
  return (
    <div css={styles.container}>
      {!showCommentBox ? (
        <div css={styles.verticalAlignRow}>
          <Button
            variant="ghost"
            size="small"
            icon={<AddIcon size="small" />}
            iconPosition="before"
            onClick={() => setShowCommentBox(true)}
            disabled={button.disabled}
            data-testid={button.dataTestId}
          >
            {button.label}
          </Button>
          <TooltipOverlay id={tooltip.id} text={tooltip.text}>
            <InfoOutlineIcon size="small" css={styles.tooltipIcon} />
          </TooltipOverlay>
        </div>
      ) : (
        <TextField
          multiline
          label={input.label}
          placeholder={_t('Add a comment...')}
          supportText={tooltip.text}
          fullWidth={true}
          maxRows={6}
          value={input.value}
          onChange={input.onChange}
          disabled={input.disabled}
        />
      )}
    </div>
  );
};

export default CommentBox;
